import { Megaphone, ListTodo, Settings, UserCircle, Building2, Boxes, ChartColumnIncreasing, Sparkles, FileText, Rocket, Palette, Settings2, CalendarClock } from 'lucide-react';

// Regular navigation items shown to all users
export const navigation = [
  {
    name: 'Setup',
    to: '/setup',
    icon: Settings2,
    testModeOnly: true,
  },
  {
    name: 'Business',
    to: '/business',
    icon: Rocket,
  },
  {
    name: 'Assets',
    to: '/assets',
    icon: Palette,
  },
  {
    name: 'Campaigns',
    to: '/campaigns',
    icon: Megaphone,
  },
  {
    name: 'Performance',
    to: '/performance',
    icon: ChartColumnIncreasing,
  },
  {
    name: 'Reports',
    to: '/reports',
    icon: FileText,
  },
  {
    name: 'Actions',
    to: '/optimizations',
    icon: Sparkles,
  },
];

// Bottom navigation items
export const bottomNavigation = [
  {
    name: 'Account',
    to: '/settings/account',
    icon: UserCircle,
  },
  {
    name: 'Organizations',
    to: '/organizations',
    icon: Building2,
  },
  // Note: Third nav item (individual org) will be dynamically generated with org name
];

// Admin-only navigation items
export const adminNavigation = [
  {
    name: 'Components',
    to: '/components',
    icon: Boxes,
  },
  {
    name: "Automations",
    to: '/tasks',
    icon: ListTodo,
  },
  {
    name: 'Scheduler',
    to: '/admin/scheduler',
    icon: CalendarClock,
  },
  {
    name: 'Glitch Admin',
    to: '/admin',
    icon: Settings,
  },
];
